import { resolveRaceId } from "../catalogs/characterSystemCatalog";

class Race {
  constructor(json) {
    this.id = resolveRaceId(json.id || json.name);
    this.size = json.size;
    this.languages = json.languages;
    this.baseSpeed = Number(json.baseSpeed);
    this.visionRange = Number(json.visionRange);
    this.vision = json.vision || "";
  }
}

export default Race;
